import { mountApp } from "@/bootstrap";
import PublicApp from "@/public/PublicApp";

mountApp(PublicApp);